import { HandlerSet, RequestRunViewOptions } from './types';
import type { PresentedStatusOverride } from '../../utils/delegation/resolvePresentedRunStatus';

export const handleRequestRunView = (
  set: HandlerSet,
  entryId: string,
  options?: RequestRunViewOptions,
) => {
  set((state) => {
    const existing = state.openByEntryId[entryId];
    const runId = options?.runId;
    const fullScreen =
      runId === undefined
        ? (options?.fullScreen ?? existing?.fullScreen ?? false)
        : false;
    return {
      openByEntryId: {
        ...state.openByEntryId,
        [entryId]: runId === undefined ? { fullScreen } : { fullScreen, runId },
      },
    };
  });
};

export const handleCloseRunView = (set: HandlerSet, entryId: string) => {
  set((state) => {
    if (!(entryId in state.openByEntryId)) {
      return {};
    }
    const { [entryId]: _removed, ...remaining } = state.openByEntryId;
    return { openByEntryId: remaining };
  });
};

export const handleSetFullScreen = (
  set: HandlerSet,
  entryId: string,
  fullScreen: boolean,
) => {
  set((state) => {
    const existing = state.openByEntryId[entryId];
    if (!existing) {
      return {};
    }
    return {
      openByEntryId: {
        ...state.openByEntryId,
        [entryId]: { ...existing, fullScreen },
      },
    };
  });
};

export const handleSetPresentedStatus = (
  set: HandlerSet,
  entryId: string,
  override: PresentedStatusOverride | null,
) => {
  set((state) => {
    const { [entryId]: current, ...others } = state.presentedStatusByEntryId;
    if (override === null) {
      return current === undefined ? {} : { presentedStatusByEntryId: others };
    }
    return {
      presentedStatusByEntryId: {
        ...state.presentedStatusByEntryId,
        [entryId]: override,
      },
    };
  });
};
